import styled from 'styled-components';
import { Dialog } from '@mui/material';

export const DialogBase = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 600px;
    width: 90%;
    padding: 24px;
    border-radius: 8px;
  }
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #333;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 24px 0;
`;

export const FileTypeSelector = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;

export const FileTypeButton = styled.button<{ isActive: boolean }>`
  flex: 1;
  padding: 12px;
  border: 2px solid ${(props) => (props.isActive ? '#1976d2' : '#e0e0e0')};
  border-radius: 8px;
  background-color: ${(props) => (props.isActive ? '#e3f2fd' : 'white')};
  color: ${(props) => (props.isActive ? '#1976d2' : '#666')};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #1976d2;
  }
`;

export const DragAndDropArea = styled.div<{ isDragging: boolean }>`
  border: 2px dashed ${(props) => (props.isDragging ? '#1976d2' : '#e0e0e0')};
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  background-color: ${(props) => (props.isDragging ? '#f5f5f5' : 'white')};
  transition: all 0.2s;
  margin-bottom: 16px;

  &:hover {
    border-color: #1976d2;
    background-color: #f5f5f5;
  }

  p {
    margin: 0;
    color: #666;
    font-size: 14px;
  }
`;

export const FileList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 24px;
`;

export const FileItem = styled.div<{ isDocument?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    !props.isDocument &&
    `
    img {
      width: 100%;
      height: 100px;
      object-fit: cover;
      border-radius: 4px;
    }
  `}

  ${(props) =>
    props.isDocument &&
    `
    img {
      width: 60px;
      height: 60px;
    }

    span {
      font-size: 12px;
      color: #666;
      text-align: center;
      margin-top: 4px;
      word-break: break-word;
      max-width: 100px;
    }
  `}
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const ErrorMessage = styled.p`
  color: #d32f2f;
  font-size: 12px;
  margin: 8px 0;
`;
